<template>
  <SheetContainer desc="" title="">
    <div class="sensitive-sheet">
      <div class="icon-closs" @click="closeSheet">
        <van-icon name="cross" />
      </div>
      <div v-if="allSensitiveCount > 0" class="sensitive-tab">
        <div class="sensitive-title">
          共检测<span class="red">{{ allSensitiveCount }}</span>处敏感词
          <div class="sheet-title-right">
            <slot name="title-right" />
          </div>
        </div>
  
        <div class="">
          <div class="card-content-container">
            <div class="card-content flex">
              <div class="card-sensitive-word">{{ currentRenderText }}</div>
              <div class="card-senditive-count">
                <span class="text-sensitive">{{ currentIndex + 1 }}</span>/<span>{{ allSensitiveCount }}</span>
              </div>
              <div class="sensitive-actions">
                <div>
                  <img :src="require('@/assets/images/editor/arrow_up.svg')" alt="上" @click="prevWord" />
                  <img :src="require('@/assets/images/editor/arrow_down.svg')" alt="下" @click="nextWord" />
                </div>
              </div>
            </div>
          </div>
          <div class="repalce-word">
            <input v-model="replaceText"  type="text" @focus="onCustomClick" placeholder="请输入要替换的文本">
            <div>{{ messageText }}</div>
          </div>
        </div>
        <div class="btn">
          <span class="sheet-item" @click="replaceSingleWord">替换</span> <span class="sheet-item"
            @click="reolaceAll">替换全部</span>
        </div>
      </div>
      <div v-if="allSensitiveCount == 0" class="success-tab">
        <div class="pic_success">
          <img :src="require('@/assets/images/editor/pic_success.svg')" alt="" srcset="">
        </div>
        <h2 class="success-title">
          当前文章未发现风险异常，可正常发布
  
        </h2>
        <div @click="closeSheet" class="dialog-btn">知道了</div>
      </div>
      <InputModal title="替换的文字:" type="text" placeholder="请输入20字以内的替换文字" :visible.sync="customInputVisible"
        :defaultValue="defaultValue" :maxLength="20" @confirm="onCustomInput" />
    </div>
  
  </SheetContainer>
</template>
<script>
import InputModal from "@/components/input-modal/input-modal.vue";
import SheetContainer from "../sheet-container/sheet-container.vue";
import { toast } from "@/utils/util";
import $ from "jquery";
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: "",
    },
    isEffectUpdate: {
      // 选中值信息
      type: Boolean,
      default: false,
    },
    sensitiveList: {
      // 敏感词列表
      type: Array,
      default: () => [],
    },

  },
  components: {
    SheetContainer,
    InputModal,
  },
  data() {
    return {
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
      customInputVisible: false, // 自定义弹窗是否显示
      currentRenderText: '',
      curWordCount: 0,
      allSensitiveCount: 0,
      defaultValue: '',
      currentIndex: 0,
      sensitiveTextList: [],
      replaceText: '',
      messageText: ''
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.phoneticsText = this.value;
      },
    },
  },
  mounted() {
    if ($('.curSensitive').length > 0) {

      let sensitiveword = $('.curSensitive').attr('data-sensitiveword')

      this.currentRenderText = sensitiveword
      this.curWordCount = $(`.sensitive${sensitiveword}`).length
      $('.curSensitive')[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
    } else {
      this.currentRenderText = this.sensitiveTextList[0]
      let $curNode = $(`.sensitive${this.currentRenderText}`)
      this.curWordCount = $curNode.length
      $curNode[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      $($curNode[0]).addClass('curSensitive')

    }
    this.allSensitiveCount = $('.sensitive').length

  },
  methods: {
    //替换className 为'sensitive傻逼`的text内容，替换为replaceText
    replaceSingleWord() {
      if (!this.replaceText) {
        toast('请输入替换内容')
        return
      };
      let replaceText = this.replaceText

      $('.curSensitive').replaceWith(`<span>${replaceText}</span>`)
      if(this.currentIndex>=$('.sensitive').length){
        this.currentIndex = 0
      }
      let curNode = $(`.sensitive`)[this.currentIndex]
      if (curNode) {
        $(curNode).addClass('curSensitive')
        curNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
        let sensitiveword = $(curNode).attr('data-sensitiveword')
        this.currentRenderText = sensitiveword
      }
      this.allSensitiveCount = $('.sensitive').length
      toast('替换成功')
    },
    //替换所有敏感词，替换为replaceText
    reolaceAll() {
      if (!this.replaceText) {
        toast('请输入替换内容')
        return
      };
      let replaceText = this.replaceText
      let sensitiveword = $('.curSensitive').attr('data-sensitiveword')
      $(`.sensitive${sensitiveword}`).replaceWith(`<span>${replaceText}</span>`)
      if ($(`.sensitive`).length > 0) {
        this.currentIndex = 0
        let curSensitive = $(`.sensitive`)[0]
        curSensitive.scrollIntoView({ behavior: 'smooth', block: 'center' })
        $(curSensitive).addClass('curSensitive')
        let sensitiveword = $(curSensitive).attr('data-sensitiveword')
        this.currentRenderText = sensitiveword
        this.curWordCount = $(`.sensitive${sensitiveword}`).length
      }
      this.allSensitiveCount = $('.sensitive').length
      toast('替换成功')
    },
    // 打开自定义弹窗
    onCustomClick() {
      this.customInputVisible = true;
      this.defaultValue=this.replaceText
    },
    // 自定义输入
    onCustomInput(value) {
      if (value) { this.replaceText = value }

    },
    // 校验选中是否合法
    prevWord() {
      let $curSensitive = $(`.sensitive`)
      if ($curSensitive.length == 1) {
        return
      }
      $('.curSensitive').removeClass('curSensitive')
      if (this.currentIndex > 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = $curSensitive.length - 1;
      }
      let curNode = $curSensitive[this.currentIndex]
      $(curNode).addClass('curSensitive')
      let sensitiveword = $(curNode).attr('data-sensitiveword')
      this.currentRenderText = sensitiveword
      curNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    nextWord() {
      let $curSensitive = $(`.sensitive`)
      if ($curSensitive.length <= 1) {
        return
      }
      $('.curSensitive').removeClass('curSensitive')
      if (this.currentIndex < $curSensitive.length - 1) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
      let curNode = $curSensitive[this.currentIndex]
      $(curNode).addClass('curSensitive')
      let sensitiveword = $(curNode).attr('data-sensitiveword')
      this.currentRenderText = sensitiveword
      curNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    closeSheet() {
      this.$emit("close", false);
    },

  },
};
</script>
<style lang="less" scoped>
@border-color: #DDDDDD;
@text-primary-color: #5a92f4;

.sensitive-sheet{
  padding: 0 8px;
}
.sensitive-tab {
  height: 412px;
}

.sensitive-title {
  font-size: 32px;
  font-family: 'HarmonyOS_Sans_SC_Medium';
  font-weight: 500;
  color: #333333;
  line-height: 40px;
}

.red {
  color: red;
}

.icon-closs {
  position: absolute;
  right: 8px;
  top: 0px;
  font-size: 32px;
}

.card-content-container {
  margin-top: 55px;
  position: relative;
  font-family: 'HarmonyOS_Sans_SC';
}

.card-content {

  border-radius: 10px;
  display: flex;
  border: 2px solid #DDDDDD;
  background: #F4F4F4;
  height: 64px;
  justify-content: flex-start;
  align-items: center;
  // overflow: hidden;

  .card-sensitive-word {
    flex-grow: 1;
    padding: 0 24px;
    line-height: 64px;
    height: 64px;
    border-right: none;
    box-sizing: border-box;
    font-size: 28px;
    color: #999999;
  }

  .card-senditive-count {
    line-height: 64px;
    height: 64px;
    padding-right: 16px;
    border-left: none;
    border-right: none;
    box-sizing: border-box;
    font-size: 26px;
    color: #333;
  }

  .sensitive-actions {
    width: 152px;
    padding: 8px 0px;
    border-left: none;
    height: 64px;
    box-sizing: border-box;

    div {
      border-left: 2px solid @border-color;
      display: flex;
      justify-content: space-evenly;
      height: 100%;
    }

    img {
      width: 25px;
      cursor: pointer;
      color: #999;
    }
  }

  .action-item {
    line-height: 38px;
    cursor: pointer;
    text-align: center;
    position: relative;
    box-sizing: border-box;
  }


}

.repalce-word {
  margin-top: 32px;
  margin-bottom: 76px;

  input {
    border-radius: 10px;
    border: 2px solid #DDDDDD;
    height: 64px;
    width: 100%;
    padding: 13px 24px;
    font-size: 28px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 400;
    color: #333;
    line-height: 38px;
    box-sizing: border-box;
    outline: none;
    &::placeholder {
      color: #ccc;
    }
  }

}

.btn {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .sheet-item {
    text-align: center;
    line-height: 64px;
    box-sizing: border-box;
    display: block;
    width: 328px;
    height: 64px;
    border-radius: 10px;
    margin-right: 0px;
    border: #3583FB 2px solid;
    font-size: 28px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 500;
    color: #3583FB;
    line-height: 62px;
  }
}

.success-tab {
  height: 412px;
  overflow: hidden;
  .pic_success {
    text-align: center;
    margin-top: 58px;
    margin-bottom: 36px;

    img {
      width: 80px;
      height: 80px;

    }
  }

  .success-title {
    font-size: 30px;
    font-family: HarmonyOS_Sans_SC_Medium;
    color: #333333;
    line-height: 40px;
    text-align: center;
    margin-bottom: 104px;
  }

  .dialog-btn {
    width: 504px;
    margin: auto;
  }
}</style>